import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import SmartLink from "common/wrapper/SmartLink";
import ArticleCardAuthor from "features/news/components/ArticleCardAuthor";
import ArticleCardTopicList from "features/news/components/ArticleCardTopicList";
import type { ResolvedArticleCard } from "resolvers/data/articleCardResolver";
import styles from "./ArticleCard.module.scss";

const cx = classNames.bind(styles);

type ArticleCardProps = ResolvedArticleCard & { prefetch?: boolean } & {
    isPinned?: boolean;
    isFeatured?: boolean;
};

const ArticleCard: React.FC<ArticleCardProps> = ({
    author,
    datePublished,
    dateModified,
    image,
    readTimeMins,
    title,
    topics,
    url,
    prefetch = false,
    isPinned,
    isFeatured,
}) => {
    return (
        <SmartLink href={url} prefetch={!!prefetch}>
            <a className={cx("link", { featured: isFeatured })}>
                <article className={cx("container", { pinned: isPinned })}>
                    <figure className={cx("imageWrap")}>
                        {!!image?.src && (
                            <Image
                                {...image}
                                alt={image.alt}
                                layout="intrinsic"
                                width={isFeatured ? 525 : 400}
                                height={isFeatured ? 420 : 215}
                                objectFit="cover"
                                className={cx("heroImage")}
                            />
                        )}
                    </figure>
                    <div className={cx("detailsWrap")}>
                        <div className={cx("details")}>
                            <h3 className={cx("title")}>{title}</h3>
                        </div>
                        <ArticleCardAuthor
                            author={author}
                            datePublished={datePublished}
                            dateModified={dateModified}
                            readTimeMins={readTimeMins}
                        />
                        <ArticleCardTopicList topics={[topics.map(({ name }) => name)[0]]} />
                    </div>
                </article>
            </a>
        </SmartLink>
    );
};

export default ArticleCard;
